/* ADVANZ · Navegación desplegable
   Apertura con intención en escritorio, acordeón en móvil, teclado completo. */

(function () {
  'use strict';
  if (window.advanzNavInit) return;
  window.advanzNavInit = true;

  var RETRASO_ABRIR = 120;
  var RETRASO_CERRAR = 200;

  document.addEventListener('DOMContentLoaded', function () {

    /* ========================================================
       ESCRITORIO
       ======================================================== */
    document.querySelectorAll('[data-nav]').forEach(function (nav) {
      var items = nav.querySelectorAll('[data-nav-item]');
      var abierto = null;
      var tAbrir = null;
      var tCerrar = null;

      function abrir(item) {
        clearTimeout(tCerrar);
        if (abierto && abierto !== item) cerrarYa(abierto);
        item.classList.add('is-open');
        var t = item.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'true');
        abierto = item;
      }

      function cerrarYa(item) {
        item.classList.remove('is-open');
        var t = item.querySelector('[data-nav-trigger]');
        if (t) t.setAttribute('aria-expanded', 'false');
        if (abierto === item) abierto = null;
      }

      function cerrarTodo() {
        items.forEach(cerrarYa);
      }

      items.forEach(function (item) {
        var trigger = item.querySelector('[data-nav-trigger]');
        if (!trigger) return;

        // El retraso evita que el panel salte cuando el mouse solo cruza
        // la barra camino al carrito.
        item.addEventListener('mouseenter', function () {
          clearTimeout(tCerrar);
          tAbrir = setTimeout(function () { abrir(item); }, RETRASO_ABRIR);
        });

        item.addEventListener('mouseleave', function () {
          clearTimeout(tAbrir);
          tCerrar = setTimeout(function () { cerrarYa(item); }, RETRASO_CERRAR);
        });

        trigger.addEventListener('click', function (e) {
          e.preventDefault();
          clearTimeout(tAbrir);
          clearTimeout(tCerrar);
          if (item.classList.contains('is-open')) cerrarYa(item);
          else abrir(item);
        });

        // Al salir del último enlace del panel con Tab, se cierra solo
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) cerrarYa(item);
        });
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && abierto) {
          var t = abierto.querySelector('[data-nav-trigger]');
          cerrarTodo();
          if (t) t.focus();
        }
      });

      document.addEventListener('click', function (e) {
        if (abierto && !abierto.contains(e.target)) cerrarTodo();
      });
    });

    /* ========================================================
       CAJÓN MÓVIL
       ======================================================== */
    var cajon = document.querySelector('[data-drawer]');
    if (!cajon) return;

    var abridor = document.querySelector('[data-drawer-open]');
    var cerrador = cajon.querySelector('[data-drawer-close]');
    var fondo = cajon.querySelector('[data-drawer-backdrop]');
    var ultimoFoco = null;

    function abrirCajon() {
      ultimoFoco = document.activeElement;
      cajon.classList.add('is-open');
      cajon.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      if (abridor) abridor.setAttribute('aria-expanded', 'true');
      setTimeout(function () { if (cerrador) cerrador.focus(); }, 60);
    }

    function cerrarCajon() {
      cajon.classList.remove('is-open');
      cajon.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (abridor) abridor.setAttribute('aria-expanded', 'false');
      if (ultimoFoco) ultimoFoco.focus();
    }

    if (abridor) abridor.addEventListener('click', abrirCajon);
    if (cerrador) cerrador.addEventListener('click', cerrarCajon);
    if (fondo) fondo.addEventListener('click', cerrarCajon);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && cajon.classList.contains('is-open')) cerrarCajon();
    });

    // Acordeón: la animación usa grid-template-rows, que el navegador
    // resuelve sin recalcular altura en cada cuadro. Barato en móviles lentos.
    cajon.querySelectorAll('[data-acc-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var padre = btn.closest('[data-acc]');
        var abierta = padre.classList.contains('is-open');

        cajon.querySelectorAll('[data-acc].is-open').forEach(function (otra) {
          if (otra !== padre) {
            otra.classList.remove('is-open');
            otra.querySelector('[data-acc-trigger]').setAttribute('aria-expanded', 'false');
          }
        });

        padre.classList.toggle('is-open', !abierta);
        btn.setAttribute('aria-expanded', String(!abierta));
      });
    });
  });
})();